export default {
    metadataNamesMappingPlural: new Map([
        ['objectClass', 'Object Classes'],
        ['property', 'Properties'],
        ['data_type', 'Data Types'],
        ['dataElementConcept', 'Data Element Concepts'],
        ['valueDomain', 'Value Domains'],
        ['dataElement', 'Data Elements'],
    ]),
    metadataNamesMappingSingular: new Map([
        ['objectClass', 'Object Class'],
        ['property', 'Property'],
        ['data_type', 'Data Type'],
        ['dataElementConcept', 'Data Element Concept'],
        ['valueDomain', 'Value Domain'],
        ['dataElement', 'Data Element'],
    ])
}
